import { Component } from '@angular/core';

@Component({
  selector: 'balance-General-Cuenta',
  styles: [],
  templateUrl: 'balanceGeneral.component.html'
})

export class BalanceGeneralComponent {}


// WEBPACK FOOTER //
// ./src/app/Contabilidad/balanceGeneral/balanceGeneral.component.ts